<!-- @format -->

<ad-detail-tag>
  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item">
        <a href="/ad" class="recruitment">公募案件を探す</a>
      </li>
      <li class="breadcrumb-item"><h1>詳細</h1></li>
    </ul>
  </div>
  <!--/.container_breadcrumb-->

  <div class="contents">
    <ul
      class="alert_message01 margin-spacing-1_bottom"
      if="{!state.basicinfoFilled}"
    >
      <li class="alert_message01-item">
        <a href="/info">
          本人確認書類が未提出です（お仕事の受託やクライアント様との交渉ができません）
        </a>
      </li>
    </ul>
    <!--/.alert_message-->
    <section class="contents_area" if="{state.error}">
      <div class="contents_block">
        <ul class="table_list">
          <li class="table_list-item">{ state.error.data.text }</li>
        </ul>
      </div>
    </section>

    <section class="contents_area" if="{'work_type' in state.detail}">
      <div class="contents_block detail">
        <div class="box_flex01 margin-spacing-1_bottom">
          <div>
            <div class="container_project-info margin-spacing-1_bottom">
              <span
                class="status_label status_label-entry margin-spacing-3_right"
                if="{state.detail.entry_state}"
              ></span>
            </div>
            <!--/.container_project-info-->
            <ul class="information_list">
              <li class="information_list-item">
                <span class="information_list-item-title">公募案件ID:</span>
                {ad_id}
              </li>
              <li class="information_list-item">
                <span class="information_list-item-title">発注元企業:</span>
                {state.detail.client_name}
              </li>
            </ul>
            <!--/.information_list-->

            <ul class="information_list">
              <li class="information_list-item">
                <span class="information_list-item-title">公募期間:</span>
                {state.detail.open_from} 〜 {state.detail.open_to}
              </li>
            </ul>
            <!--/.information_list-->
          </div>
          <!-- prettier-ignore -->
          <div
            class="button button-tertiary kininaru { state.detail.in_interest ? 'done' : ''}"
            onclick="{ onInterest }"
          ></div>
        </div>

        <h2 class="matter_heading-detail margin-spacing-2_bottom">
          {state.detail.title}
        </h2>
        <div class="text margin-spacing-2_bottom">
          <ul>
            <li>
              <span style="font-weight: bold">仕事内容：</span>
              <span each="{(item,index) in state.detail.work_type.show_items}">
                {item.jname}
              </span>
            </li>
            <li>
              <span style="font-weight: bold">コンテンツ形式：</span>
              <!-- prettier-ignore -->
              <span each="{(item,index) in state.detail.text_content_type.show_items}">
                {item.group_jname}
                (
                  {item.jname}
                  { (item.memo != "") ? ":" + item.memo : ""}
                )
                {( (index + 1) < state.detail.text_content_type.show_items.length ) ? " / " : ""}
              </span>
            </li>
          </ul>
        </div>

        <p class="text margin-spacing-2_bottom">
          <span each="{ (line,index) in state.detail.description.split('\n')}">
            {line}
            <br />
          </span>
        </p>

        <div class="matter-info">
          <ul
            class="matter-info_list margin-spacing-1_bottom"
            style="display: block"
          >
            <li class="matter-info_list-item">
              <span class="matter-info_list-item-title">掲載予定媒体:</span>

              <!-- prettier-ignore -->
              <span each="{(item,index) in state.detail.target_medias.show_items}">
                {item.jname}
                { (item.memo != "") ? "(" + item.memo + ")" : ""}
                {((index + 1) < state.detail.target_medias.show_items.length) ? " / " : ""}
              </span>
            </li>

            <li class="matter-info_list-item">
              <span class="matter-info_list-item-title">ジャンル・テーマ:</span>

              <!-- prettier-ignore -->
              <span each="{(item,index) in state.detail.text_content_genres.show_items}">
                {item.jname}
                { (item.memo != "") ? "(" + item.memo + ")" : ""}
                {((index+1) < state.detail.text_content_genres.show_items.length) ? " / " : ""}
              </span>
            </li>

            <li class="matter-info_list-item">
              <span class="matter-info_list-item-title">想定ターゲット:</span>
              <span
                each="{ (line,index) in state.detail.target_reader.split('\n') }"
              >
                {line}
                <br />
              </span>
            </li>
          </ul>
          <!--/.information_list-->
        </div>
        <!--/.matter-info-->

        <table class="detail_table">
          <tr class="detail_table-row">
            <th class="detail_table-heading">作業範囲</th>
            <td class="detail_table-data">
              <ul class="scope-detail_list">
                <li
                  class="scope-detail_list-item"
                  each="{(scope_name,index) in Object.keys(state.detail.working_scope) }"
                  if="{state.detail.working_scope[scope_name].show_items[0]}"
                >
                  {state.detail.working_scope[scope_name].item_jname} :

                  <span
                    if="{scope_name != 'working_scope_image_selection_title'}"
                    each="{ (item,item_index) in state.detail.working_scope[scope_name].show_items}"
                    style="font-weight: normal"
                  >
                    {item.jname}
                  </span>

                  <!--
                  <ul class="scope-detail_sublist" if="{scope_name != "working_scope_image_selection_title"}">
                    <li class="scope-detail_sublist-item" each="{ (item,item_index) in state.detail.working_scope[scope_name].show_items}">
                      {item.jname}
                    </li>
                  </ul>
                  -->

                  <ul
                    class="scope-detail_sublist"
                    if="{scope_name == 'working_scope_image_selection_title'}"
                  >
                    <li class="scope-detail_sublist-item">
                      {state.detail.working_scope[scope_name].show_items[0]['value']}枚
                    </li>
                  </ul>

                  <div
                    if="{scope_name == 'working_scope_notation_rule'}"
                    style="margin: 1em"
                  >
                    <ul class="scope-detail_sublist">
                      <li
                        class="scope-detail_sublist-item"
                        if="{state.detail.working_scope['working_scope_notation_rule']['memos']['working_scope_notation_rule_memo_kanji'] != ''}"
                      >
                        表記ルール内容｜漢字 :
                        <span style="font-weight: normal">
                          {state.detail.working_scope['working_scope_notation_rule']['memos']['working_scope_notation_rule_memo_kanji']}
                        </span>
                      </li>
                      <li
                        class="scope-detail_sublist-item"
                        if="{state.detail.working_scope['working_scope_notation_rule']['memos']['working_scope_notation_rule_memo_kana'] != ''}"
                      >
                        表記ルール内容｜ひらがな :
                        <span style="font-weight: normal">
                          {state.detail.working_scope['working_scope_notation_rule']['memos']['working_scope_notation_rule_memo_kana']}
                        </span>
                      </li>
                      <li
                        class="scope-detail_sublist-item"
                        if="{state.detail.working_scope['working_scope_notation_rule']['memos']['working_scope_notation_rule_memo_english'] != ''}"
                      >
                        表記ルール内容｜英語 :
                        <span style="font-weight: normal">
                          {state.detail.working_scope['working_scope_notation_rule']['memos']['working_scope_notation_rule_memo_english']}
                        </span>
                      </li>
                      <li
                        class="scope-detail_sublist-item"
                        if="{state.detail.working_scope['working_scope_notation_rule']['memos']['working_scope_notation_rule_memo_num'] != ''}"
                      >
                        表記ルール内容｜数字 :
                        <span style="font-weight: normal">
                          {state.detail.working_scope['working_scope_notation_rule']['memos']['working_scope_notation_rule_memo_num']}
                        </span>
                      </li>
                      <li
                        class="scope-detail_sublist-item"
                        if="{state.detail.working_scope['working_scope_notation_rule']['memos']['working_scope_notation_rule_memo_symbol'] != ''}"
                      >
                        表記ルール内容｜記号 :
                        <span style="font-weight: normal">
                          {state.detail.working_scope['working_scope_notation_rule']['memos']['working_scope_notation_rule_memo_symbol']}
                        </span>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </td>
          </tr>

          <tr
            class="detail_table-row"
            if="{state.detail.working_scope_urls.length > 0}"
          >
            <th class="detail_table-heading">参考URL</th>
            <td class="detail_table-data">
              <ul
                class="reference_list"
                each="{ url in state.detail.working_scope_urls }"
              >
                <li class="reference_list-item">
                  <a
                    class="reference_list-item_website"
                    href="{url}"
                    target="_blank"
                  >
                    {url}
                  </a>
                </li>
              </ul>
            </td>
          </tr>

          <tr
            class="detail_table-row"
            if="{state.detail.working_scope_files.length > 0}"
          >
            <th class="detail_table-heading">添付ファイル</th>
            <td class="detail_table-data">
              <ul
                class="reference_list"
                each="{ file in state.detail.working_scope_files }"
              >
                <li class="reference_list-item">
                  <a
                    class="reference_list-item_documents"
                    onclick="{e=>download(file.hash)}"
                  >
                    {file.origin_name}
                  </a>
                </li>
              </ul>
            </td>
          </tr>

          <tr class="detail_table-row">
            <th class="detail_table-heading">補足コメント</th>
            <td class="detail_table-data">
              <p
                class="text"
                each="{ (line,index) in state.detail.working_scope_memo.split('\n') }"
              >
                {line}
              </p>
            </td>
          </tr>

          <tr if="{0}" class="detail_table-row">
            <th class="detail_table-heading">あると望ましいスキル・経験など</th>
            <td class="detail_table-data" style="font-size: 1.5rem">
              <dl style="margin-bottom: 1.5em">
                <dt>年齢層：***</dt>
                <dd></dd>
              </dl>

              <dl style="margin-bottom: 1.5em">
                <dt>性別：***</dt>
                <dd></dd>
              </dl>

              <dl style="margin-bottom: 1.5em">
                <dt>経験年数</dt>
                <dd>
                  <ul class="scope-detail_list" style="margin: 2em">
                    <li
                      class="scope-detail_list-item"
                      each="{item in state.detail.worker_condition_career_year.show_items}"
                      if="{item.year_info != null}"
                    >
                      {item.jname}:{item.year_info.year_number_jname}
                    </li>
                  </ul>
                </dd>
              </dl>

              <dl
                style="margin-bottom: 1.5em"
                if="{state.detail.worker_condition_experienced_medias.show_items.length >= 1}"
              >
                <dt>編集・執筆したことがある媒体</dt>
                <dd>
                  <ul class="scope-detail_list" style="margin: 1em">
                    <li
                      class="scope-detail_list-item"
                      each="{show_item in state.detail.worker_condition_experienced_medias.show_items}"
                    >
                      {show_item.detail_type_jname}
                      <ul class="scope-detail_sublist">
                        <li
                          class="scope-detail_sublist-item"
                          each="{media in show_item.items}"
                        >
                          {media.jname} { (media.memo != "") ? "(" + media.memo
                          + ")" : "" }
                        </li>
                      </ul>
                    </li>
                  </ul>
                </dd>
              </dl>

              <dl
                style="margin-bottom: 1.5em"
                if="{state.detail.worker_condition_experienced_contents.show_items.length >= 1}"
              >
                <dt>編集・執筆したことがあるコンテンツ記事</dt>
                <dd>
                  <ul class="scope-detail_list" style="margin: 1em">
                    <li
                      class="scope-detail_list-item"
                      each="{show_item in state.detail.worker_condition_experienced_contents.show_items}"
                    >
                      {show_item.detail_type_jname}
                      <ul class="scope-detail_sublist">
                        <li
                          class="scope-detail_sublist-item"
                          each="{media in show_item.items}"
                        >
                          {media.jname} { (media.memo != "") ? "(" + media.memo
                          + ")" : "" }
                        </li>
                      </ul>
                    </li>
                  </ul>
                </dd>
              </dl>

              <dl
                style="margin-bottom: 1.5em"
                if="{state.detail.worker_condition_work_skills.show_items.length >= 1}"
              >
                <dt>編集・執筆関連スキル</dt>
                <dd>
                  <ul class="scope-detail_list" style="margin: 1em">
                    <li
                      class="scope-detail_list-item"
                      each="{show_item in state.detail.worker_condition_work_skills.show_items}"
                    >
                      {show_item.detail_type_jname}
                      <ul class="scope-detail_sublist">
                        <li
                          class="scope-detail_sublist-item"
                          each="{media in show_item.items}"
                        >
                          {media.jname} { (media.memo != "") ? "(" + media.memo
                          + ")" : "" }
                        </li>
                      </ul>
                    </li>
                  </ul>
                </dd>
              </dl>

              <dl style="margin-bottom: 1.5em">
                <dt>関心のあるジャンル</dt>
                <dd>ほんぶん(あとでさしかえ)</dd>
              </dl>

              <dl style="margin-bottom: 1.5em">
                <dt>経験した業種・業界</dt>
                <dd>ほんぶん(あとでさしかえ)</dd>
              </dl>

              <dl style="margin-bottom: 1.5em">
                <dt>経験した職種</dt>
                <dd>ほんぶん(あとでさしかえ)</dd>
              </dl>

              <dl style="margin-bottom: 1.5em">
                <dt>資格</dt>
                <dd>ほんぶん(あとでさしかえ)</dd>
              </dl>
            </td>
          </tr>

          <tr class="detail_table-row">
            <th class="detail_table-heading">
              依頼したいテキストコンテンツのファイル形式
            </th>
            <td class="detail_table-data">
              <ul class="scope-detail_list">
                <li
                  class="scope-detail_list-item"
                  each="{show_item in state.detail.delivery_file_type.show_items}"
                >
                  {show_item.jname}
                </li>
              </ul>

              <p
                class="comment"
                each="{ (line,index) in state.detail.delivery_file_type_memo.split('\n') }"
              >
                {line}
              </p>
            </td>
          </tr>

          <tr class="detail_table-row">
            <th class="detail_table-heading">制作物の数</th>
            <td class="detail_table-data">
              <ul class="scope-detail_list">
                <li class="scope-detail_list-item">
                  {state.detail.volume}{di.Edilent.cTypeProps(state.detail.text_content_type.items.group_ids).num}
                </li>
              </ul>
              <p class="comment">
                ※分納方式で報酬の支払いを行いますので、複数の制作物依頼でも1納品（検収合格）する毎に報酬が支払われます。
              </p>
            </td>
          </tr>

          <tr class="detail_table-row">
            <th class="detail_table-heading">初回提出期限</th>
            <td class="detail_table-data">
              <ul class="scope-detail_list">
                <li
                  class="scope-detail_list-item"
                  each="{ (delivery_hope_datetimes_item,index) in state.detail.delivery_hope_datetimes }"
                >
                  制作物{index + 1}：{delivery_hope_datetimes_item}
                </li>
              </ul>
            </td>
          </tr>

          <tr class="detail_table-row">
            <th class="detail_table-heading">修正回数上限</th>
            <td class="detail_table-data">
              <ul class="scope-detail_list">
                <li class="scope-detail_list-item">
                  {state.detail.max_retake_count}回
                </li>
              </ul>
              <p class="comment">
                （目安であり、事情、理由によってはこの限りではありません）
              </p>
            </td>
          </tr>

          <tr class="detail_table-row">
            <th colspan="1" class="detail_table-heading">
              あると望ましいスキル・経験など
            </th>
            <td colspan="1" class="detail_table-data">
              <div
                each="{item in state.detail.worker_condition_tree}"
                is="{item.tag}"
                item="{item}"
              ></div>
            </td>
          </tr>

          <tr
            class="detail_table-row"
            if="{!di.Edilent.isNonCharContentType(state.detail.text_content_type.items.group_ids)}"
          >
            <th class="detail_table-heading">
              {di.Edilent.cTypeProps(state.detail.text_content_type.items.group_ids).title}
            </th>
            <td class="detail_table-data">
              <ul class="scope-detail_list">
                <li class="scope-detail_list-item">
                  <number-format
                    number="{state.detail.char_count_per_post}"
                  ></number-format>
                  {di.Edilent.cTypeProps(state.detail.text_content_type.items.group_ids).unit}
                </li>
              </ul>
            </td>
          </tr>

          <tr class="detail_table-row">
            <th class="detail_table-heading">1制作物あたりの報酬単価</th>
            <td class="detail_table-data">
              <ul class="scope-detail_list">
                <li class="scope-detail_list-item">
                  <number-format
                    number="{state.detail.money_info.unit_price_per_post_min}"
                  ></number-format>
                  〜
                  <number-format
                    number="{state.detail.money_info.unit_price_per_post_max}"
                  ></number-format>
                  円（税抜）
                </li>
              </ul>
              <p
                style="font-size: 1.25rem"
                if="{state.detail.money_info.company_type == 2}"
              >
                源泉を差し引いた最小単価の報酬額：
                <span>
                  <number-format
                    number="{state.detail.money_info.reward_unit_price}"
                  ></number-format>
                </span>
                円
              </p>
            </td>
          </tr>

          <tr class="detail_table-row">
            <th class="detail_table-heading">報酬想定総額</th>
            <td class="detail_table-data">
              <ul class="scope-detail_list">
                <li class="scope-detail_list-item">
                  <number-format
                    number="{state.detail.money_info.price_min_project}"
                  ></number-format>
                  〜
                  <number-format
                    number="{state.detail.money_info.price_max_project}"
                  ></number-format>
                  円（税抜）
                </li>
              </ul>
              <p
                style="font-size: 1.25rem"
                if="{state.detail.money_info.company_type == 2}"
              >
                源泉を差し引いた最小単価の報酬額：
                <span>
                  <number-format
                    number="{state.detail.money_info.amount_project}"
                  ></number-format>
                </span>
                円
              </p>
            </td>
          </tr>
        </table>
        <!--/.detail_table-->

        <div class="wrap_button margin-spacing-3_top">
          <div
            class="
              button button-secondary-large button-entry button-chat
              margin-spacing-1_right
            "
            onclick="{(e)=>chat(e)}"
            if="{state.detail.in_entry && state.detail.entry_state === 300}"
          >
            チャットを送る
          </div>
          <div
            class="
              button button-secondary-large button-border button-chat
              margin-spacing-1_right
            "
            onclick="{goQuestion}"
          >
            質問をする
          </div>
          <div
            class="button button-secondary-large button-entry"
            onclick="{(e)=>openConfirmModal(e)}"
            if="{!state.detail.in_entry}"
          >
            エントリーする
          </div>
        </div>

        <div id="qa_list"></div>
        <h3 class="heading-04 margin-spacing-5_top margin-spacing-2_bottom">
          この公募案件に対する質問・回答一覧
        </h3>
        <div class="container_qa">
          <div class="wrap_qa" each="{q in state.questions}">
            <div class="box_qa">
              <div class="user">
                <div class="user-icon">
                  <img
                    src="/assets/img/icon_account.svg"
                    alt=""
                    if="{!q.worker_icon}"
                  />
                  <img src="{q.worker_icon}" alt="" if="{q.worker_icon}" />
                </div>
                <div class="user-name">{q.worker_name}</div>
              </div>
              <!--/.user-->
              <div class="box_qa-message">
                <p
                  class="text"
                  each="{(question_line_text) in q.question.split('\n')}"
                >
                  {question_line_text}
                </p>
              </div>
              <p class="message_date align_r margin-spacing-2_top">
                {q.asked_at}
              </p>
            </div>
            <!--/.box_qa-->
            <div
              class="box_qa answer"
              if="{q.answered_at && q.answer && q.answered_bizid}"
            >
              <div class="user">
                <div class="user-icon">
                  <img src="/assets/img/icon_account.svg" alt="" />
                </div>
                <div class="user-name">{state.detail.client_name}</div>
              </div>
              <!--/.user-->
              <div class="box_qa-message">
                <p
                  class="text"
                  each="{(ans_line_text) in q.answer.split('\n')}"
                >
                  {ans_line_text}
                </p>
              </div>
              <p class="message_date align_r margin-spacing-2_top">
                {q.answered_at}
              </p>
            </div>
            <!--/.box_qa-->
          </div>
          <!--/.wrap_qa-->
          <edilent-pagination-tag
            pager="{state.pager}"
            onpager="{(e,page)=>select(e,page)}"
            if="{state.pager.last > 1}"
          ></edilent-pagination-tag>

          <a name="q"></a>
          <h3 class="heading-04 margin-spacing-5_top margin-spacing-2_bottom">
            質問文
          </h3>
          <textarea
            name="question"
            class="textarea_input margin-spacing-1_bottom"
            placeholder="ここに質問文を記入してください"
          ></textarea>
          <div class="box_flex04">
            <div
              class="button button-secondary button-send"
              onclick="{(e)=>question(e)}"
            >
              送信する
            </div>
          </div>
        </div>
        <!--/.container_qa-->
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->
  <entry-confirm-modal-tag
    onSubmit="{onSubmit}"
    isOpen="{confirmModalIsOpen}"
    onClose="{closeConfirmModal}"
  ></entry-confirm-modal-tag>

  <script>
    import di from "dependency-injection";
    import entryConfirm from "@tags/modal/ad/entry-confirm.riot";
    import categoryTag from "@tags/parts/ad/detail/category.riot";
    import groupTag from "@tags/parts/ad/detail/group.riot";
    import plainTag from "@tags/parts/ad/detail/plain.riot";

    export default {
      di: di,
      components: {
        "entry-confirm-modal-tag": entryConfirm,
        "category-tag": categoryTag,
        "plain-tag": plainTag,
        "group-tag": groupTag,
      },
      ad_id: false,
      confirmModalIsOpen: false,
      state: {
        basicinfoFilled: true,
        detail: {},
        limit: 5,
        page: 1,
        questions: {},
        pager: { page: 1, total: 0, last: 0, prev: 0, next: 0 },
      },
      chat(e) {
        this.api
          .request("detail", "open-chat", { id: this.ad_id })
          .then((data) => di.router.push(data));
      },
      closeConfirmModal(e) {
        this.confirmModalIsOpen = false;
        this.update();
      },
      openConfirmModal(e) {
        this.confirmModalIsOpen = true;
        this.update();
      },
      onSubmit() {
        this.confirmModalIsOpen = false;
        this.update();
        this.api
          .request("detail", "entry", { ad_id: this.ad_id })
          .then((data) => {
            di.router.push(`/ad/detail/${this.ad_id}/entry`);
            window.analytics.event("select_content", {
              content_type: "ad_entry",
              items: [{ id: String(this.ad_id) }],
            });
          })
          .catch((err) => alert(err));
      },
      goQuestion() {
        location.href = "#q";
      },
      download(hash) {
        this.api
          .request("detail", "download", { ad_id: this.ad_id, hash: hash })
          .then((data) => {
            const downLoadLink = document.createElement("a");
            downLoadLink.href = data;
            downLoadLink.click();
          });
      },
      question(e) {
        const question = this.$("textarea[name=question]").value;
        if (!question) {
          alert("質問が入力されていません");
          return;
        }
        this.$("textarea[name=question]").value = "";
        this.api
          .request("detail", "ask-question", {
            ad_id: this.ad_id,
            question: question,
          })
          .then((data) => this.fetchQuestion())
          .catch((err) => alert(err));
      },
      select(e, page) {
        e.preventDefault();
        this.state.page = page;
        this.fetchQuestion();
      },
      fetchQuestion() {
        this.api
          .request("detail", "fetch-question", {
            ad_id: this.ad_id,
            page: this.state.page,
            limit: this.state.limit,
          })
          .then((data) =>
            this.update({
              questions: data.items,
              pager: data,
              page: data.page,
            })
          );
      },
      fetchBasicinfoFilled() {
        di.createApi("menu")
          .request("index", "check-basic-info-filled")
          .then((data) => this.update({ basicinfoFilled: data }));
      },
      onBeforeMount(props, state) {
        if (!props.routeParams[0]) {
          return;
        }
        this.interestApi = di.createApi("interest");
        this.ad_id = props.routeParams[0];
        this.api = di.createApi("ad");
        this.api
          .request("detail", "fetch-detail", { id: this.ad_id })
          .then((data) => this.update({ detail: data }))
          .catch((data) => this.update({ error: data }));
        this.fetchQuestion();
        this.fetchBasicinfoFilled();
      },
      async onInterest(e) {
        if (this.state.detail.in_interest) {
          return;
        }
        try {
          const res = await this.interestApi.request("ad", "register", {
            ad_ids: [this.state.detail.ad_id],
          });
          this.state.detail.in_interest = true;
          this.update({ detail: this.state.detail });
          di.toast.push(`気になるを登録しました`, "success");
        } catch (e) {
          di.toast.push(e, "negative");
        }
      },
    };
  </script>
</ad-detail-tag>
